import { useToast } from '@app/core/notifications';
import { ModalController, ModalTrigger } from '@mi-front/ui';
import { Replay as RestartIcon, RecordVoiceOver as TranscriptionIcon } from '@mui/icons-material';
import { Button } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';
import { apiClient } from '../../../../../../../api';
import { Fragment } from '../../../../../types';
import { TranscriptionStartDialog } from './TranscriptionStartDialog';

interface Props {
  fragment: Fragment;
  trigger?: ModalTrigger;
  onStarted?: () => void;
  retry?: boolean;
}

export function TranscriptionStart({ onStarted, fragment, trigger, retry }: Props) {
  const { formatMessage } = useIntl();
  const { notifySuccess } = useToast();

  const defaultTrigger: ModalTrigger = (open) => (
    <Button
      size="small"
      variant="outlined"
      color="info"
      onClick={open}
      startIcon={retry ? <RestartIcon /> : <TranscriptionIcon />}
    >
      {retry ? (
        <FormattedMessage
          id="fragments.transcriptionStart.retry"
          defaultMessage="Reintentar transcripción"
        />
      ) : (
        <FormattedMessage
          id="fragments.transcriptionStart.btnText"
          defaultMessage="Transcribir fragmento"
        />
      )}
    </Button>
  );

  return (
    <ModalController trigger={trigger || defaultTrigger}>
      {(modalProps) => (
        <TranscriptionStartDialog
          data={{}}
          onSubmit={async (data) => {
            await apiClient.fragments.transcriptionStart(fragment.id, data, retry);

            notifySuccess(
              formatMessage({
                id: 'fragments.transcriptionStart.started',
                defaultMessage: 'Transcripción iniciada',
              }),
            );

            modalProps.onHide();

            onStarted && onStarted();
          }}
          {...modalProps}
        />
      )}
    </ModalController>
  );
}
